export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-overlay/index.js